import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { pills as Pills } from '@breezeway/brzw-components';
import { TASK_PRIORITIES } from '../../utils/task';

import './priority_pill.scss';

const getPriorityIcon = code => {
  switch (code) {
    case TASK_PRIORITIES.WATCH:
      return 'watch';
    case TASK_PRIORITIES.LOW:
      return 'low';
    case TASK_PRIORITIES.NORMAL:
      return 'medium';
    case TASK_PRIORITIES.HIGH:
      return 'high';
    case TASK_PRIORITIES.URGENT:
      return 'urgent';
    default:
      return null;
  }
};

const PriorityPill = ({ alignIcon, className, code, disabled, name, shouldBeUppercase }) => {
  if (!_.isEmpty(name)) {
    return (
      <Pills.PillToggle
        alignIcon={alignIcon}
        className={classnames('priority-pill', className, {
          [`priority-pill--${code}`]: code,
          [`priority-pill--uppercase`]: shouldBeUppercase,
        })}
        disabled={disabled}
        icon={getPriorityIcon(code)}
        iconClassName="priority-pill__icon"
        text={name}
      />
    );
  }
  return null;
};

PriorityPill.propTypes = {
  alignIcon: PropTypes.string,
  className: PropTypes.string,
  code: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  shouldBeUppercase: PropTypes.bool,
};

PriorityPill.defaultProps = {
  alignIcon: 'left',
  className: '',
  disabled: true,
  shouldBeUppercase: false,
};

export default PriorityPill;
